document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.form-contact');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault(); // Stop Shopify default submit

    const formData = new FormData(form);

    // -----------------------------
    // CORE FIELDS
    // -----------------------------
    const name = formData.get('contact[Name]') || '';
    const email = formData.get('contact[email]') || '';
    const mobile = formData.get('contact[Phone]') || '';

    // -----------------------------
    // MESSAGE (dynamic key safe)
    // -----------------------------
    let message = '';
    formData.forEach((value, key) => {
      if (key.toLowerCase().includes('message')) {
        message = value;
      }
    });

    // -----------------------------
    // OTHER DETAILS
    // -----------------------------
    const otherDetails = {};

    formData.forEach((value, key) => {
      if (
        key !== 'contact[Name]' &&
        key !== 'contact[email]' &&
        key !== 'contact[Phone]' &&
        !key.toLowerCase().includes('message')
      ) {
        // Clean key name
        const cleanKey = key.replace('contact[', '').replace(']', '');
        otherDetails[cleanKey] = value;
      }
    });

    // Email should stay inside otherDetails
    otherDetails.email = email;

    // -----------------------------
    // FINAL PAYLOAD
    // -----------------------------
    const payload = {
      name: name,
      mobileNo: mobile,
      note: message,
      otherDetails: otherDetails,
    };

    console.log('Sending payload:', payload);

    try {
      const response = await fetch(
        'https://cladbe-solutions-1080990601709.asia-south1.run.app/create-lead',
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "x-client-id": "B",
            "key": "ellemora123456",
            "form-id": "123456",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      console.log('Cladbe API Response:', data);

      if (response.ok) {
        alert('Form submitted successfully!');
        form.reset();
      } else {
        alert(data.message || 'Submission failed');
      }
    } catch (error) {
      console.error('Cladbe API Error:', error);
      alert('Something went wrong. Please try again.');
    }
  });
});